import styled from 'styled-components'

export const NavBarWrapper = styled.div`
background-color: #c00 ;

.navbar-light .navbar-brand , .nav-item, .navbar-light .navbar-nav .nav-link{
    color: #fff;
    font-size: 16px;
    font-weight: 500;
}

.nav-item{
    padding: 0 15px;
}
.dropdown{
    &:hover{
        text-decoration: underline;
    }
}

.search-bar{
    position: relative;
    max-width: 472px;
    min-width: 195px;
    width: 100%;
}

.form-inline{
    justify-content: flex-end;
    width: 100%;
}

#basic-navbar-nav{
    justify-content: space-between;
}

.wrapper-search{
    display: flex;
    width: 50%;
    position: relative;
    align-items: center;
    justify-content: center;
}
.search-icon{
    position: absolute;
    color: #c00;
    right: 30px;
}

`

export const IconWrapper = styled.div`
margin-left: 30px;
display: flex;
    justify-content: center;
    align-items: center;

.text{
    display: flex; 
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //width: 43px;
    font-size: 12px;
    color: #fff;
    font-weight: 700;
    margin: 0 20px;
}

.nav-icons{
    margin: 0 20px;
    padding: 10px;
    border-radius: 50%;
    &:hover{
        cursor: pointer;
        background-color: rgba(0,0,0,.09);

    }
}

`